import { render, staticRenderFns } from "./RecursoGeneral.vue?vue&type=template&id=39d207a9&"
import script from "./RecursoGeneral.vue?vue&type=script&lang=js&"
export * from "./RecursoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports